// apps/web/src/views/IdleModal.tsx
import { ModalOverlay } from '../components/ModalOverlay.js';

interface Props {
  remainingMs: number;
  onDismiss: () => void;
}

function formatMSS(ms: number): string {
  const totalSec = Math.max(0, Math.ceil(ms / 1000));
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function IdleModal({ remainingMs, onDismiss }: Props) {
  return (
    <ModalOverlay
      role="dialog"
      aria-modal="true"
      aria-labelledby="idle-title"
      className="z-50 bg-ink-900/60"
    >
      <div className="max-w-sm w-[90%] mx-auto rounded-lg bg-canvas-light dark:bg-canvas-dark p-6 shadow-lg ring-1 ring-ink-900/10 dark:ring-white/10">
        <h2 id="idle-title" className="text-lg font-semibold text-ink-900 dark:text-ink-100">
          Are you still there?
        </h2>
        <p className="mt-2 text-sm text-ink-700 dark:text-ink-300">
          You've been inactive for 2 hours. You'll be signed out in{' '}
          <span className="font-mono font-semibold tabular-nums">{formatMSS(remainingMs)}</span>{' '}
          to keep the lobby roster accurate.
        </p>
        <div className="mt-5 flex justify-end">
          <button
            type="button"
            autoFocus
            onClick={onDismiss}
            className="px-4 py-2 rounded-md bg-signwow text-ink-900 font-medium hover:brightness-95 transition"
          >
            I'm here
          </button>
        </div>
      </div>
    </ModalOverlay>
  );
}
